import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import { ListItemGraphic} from 'rmwc/List';
import ReactTooltip from 'react-tooltip'
import {stateToHTML} from 'draft-js-export-html';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {Editor as DiffEditor} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class ResourceComponent extends Component {
	constructor(props) {
		super(props)
    	this.state = {
            detailsView: false,
            associationChanged: false,
            uploadDisableButton: false,
    		moreDetails: false,
            modifyForm: false,
            submitReviewButton: true,
            parentAspect: [],
            parentStandard: [],
            parentTrack: [],
            parentBuzzword: [],
            associatedResource: [],
            saveDisable: false,
    		data: {
                resourceId: '',
	    		resourceName: '',
	    		resourceLink: '',
	    		resourceAuthor: '',
	    		resourceDescription: '',
	    		resourceLanguage: '',
	    		resourceCreationDate: '',
                resourceStatus: '',
                resourceType: '',
                languageId: '',
                resourceComplexity: '',
                complexityId: '',
                buzzwords: '',
                ratings: '',
                preReads: [],
                postReads: [],
                centaRating: '',
                resourceClass: '',
                resourceCustomId: '',
                listingSequence: '',
                imgLink: '',
                active: 1,
                blogId: ''
	    	},
            editData: {
                resourceId: '',
                resourceName: '',
                resourceLink: '',
                resourceAuthor: '',
                resourceDescription: '',
                resourceLanguage: '',
                resourceCreationDate: '',
                resourceStatus: '',
                resourceType: '',
                languageDropDown: [],
                languageId: '',
                trackDropDown: [],
                levelDropDown: [],
                levelId: '',
                buzzwordDropDown: [],
                resourceDropDown: [],
                complexityId: '',
                complexityDropDown: [],
                centaRating: '',
                centaRatingDropDown: [],
                resourceClass: '',
                aspectComboDropDown: [],
                standardComboDropDown: [],
                resourceCustomId: '',
                resourceListingSequence: '',
                resourceImgLink: '',
                active: 1,
                blogIdDropDown: [],
                blogId: ''
            },
            editorData: {
                htmlText: '',
                editorState: EditorState.createEmpty(),
                contentValue:'',
                contentState:'',
                editorStateRead:EditorState.createEmpty(),
            },
            userActivityData: {
                comment: '',
                readStatus: false,
                bookmarkStatus: false,
                archiveStatus: false,
                rating: '0.0',
                existingRating: '',
                userReviews: [],
                targetMonthDropDown: [],
                userSelectedMonth: ''
            },
            targetMonth: '',
            changeTargetMonth: true,
            userRatingView: '',
            errorMsg: '',
            fileError: ''
    	}
    }

    handleDetails = (e) => {
        let userActivityData = Object.assign({}, this.state.userActivityData)
        let data = Object.assign({}, this.state.data)

    	if (this.state.moreDetails === false) {
            if (this.props.isAdmin === false) {
                let fetchUserActivity = `learning_res_user_activity/${this.state.data.resourceId}`
                let noOfMonths = 12
                let fetchNextMonths = `future_months/${noOfMonths}`
                let fetchResourceAssociations = `user/learning_resource/render_resource_association/${this.state.data.resourceId}`
                api.getUserResponse(this.props.user.accessToken, fetchUserActivity)
                .then((result) => {
                    if (result.status === 'success'){
                        userActivityData.readStatus = result.data.read_status? result.data.read_status: false;
                        userActivityData.bookmarkStatus = result.data.bookmark_status? result.data.bookmark_status: false;
                        userActivityData.archiveStatus = result.data.archive_status? result.data.archive_status: false;
                        userActivityData.existingRating = result.data.ratings? result.data.ratings: '';
                        if ((result.data.target_month_label !== '') || (result.data.target_month_label !== null)) {
                            userActivityData.userSelectedMonth = result.data.target_month_label
                            this.setState({changeTargetMonth: false})
                        }
                        userActivityData.comment = result.data.comment
                        if (result.data.comment === null){
                            this.setState({submitReviewButton: true})
                        }
                        else {
                            this.setState({submitReviewButton: false})
                        }
                        if (result.data.ratings === null){
                            this.setState({userRatingView: 'not_rated'})
                        }
                        else {
                            this.setState({userRatingView: 'rated'})
                        }
                        this.setState({userActivityData: userActivityData, moreDetails: true, errorMsg: '', detailsView: true})
                    }
                    else {
                        userActivityData.comment = result.data.comment
                        if (result.data.comment === null){
                            this.setState({submitReviewButton: true})
                        }
                        else {
                            this.setState({submitReviewButton: false})
                        }
                        this.setState({moreDetails: true, userRatingView: 'not_rated', detailsView: true, userActivityData: userActivityData})
                    }
                    api.getUserResponse(this.props.user.accessToken, fetchResourceAssociations)
                    .then((result) => {
                        if (result.status === 'success'){
                            data.preReads = result.data.pre
                            data.postReads = result.data.post
                            api.getUserResponse(this.props.user.accessToken, fetchNextMonths)
                            .then((result) => {
                                if (result.status === 'success'){
                                    userActivityData.targetMonthDropDown = result.data
                                    this.setState({userActivityData: userActivityData, data: data})
                                }
                            })
                        }
                    })
                })
            }
            else {
                let fetchPrePostResource = `admin/learning_resource/render_pre_and_post_resources/${this.state.data.resourceId}`
                api.getResponse(this.props.user.accessToken, fetchPrePostResource)
                .then((result) => {
                    if (result.status === 'success'){
                        data.preReads = result.data.pre
                        data.postReads = result.data.post
                        this.setState({data: data})
                    }
                })
                this.setState({moreDetails: true, errorMsg: '', detailsView: true})
            }
    	}
    	else {
    		this.setState({moreDetails: false, errorMsg: '', detailsView: true})
    	}
    }

    handleParentAspectChange = (option) => {
        this.handleFetchAssociatedStandards(option)
        this.setState(state => {
            return {
                parentStandard: [],
                parentAspect : option
            };
        });
    }

    handleFetchAssociatedStandards = (option) => {
        let selectedAspect = []
        let editData = Object.assign({}, this.state.editData)

        var myAspectArray = option;
        var aspectLength = myAspectArray.length;
        for (var i = 0; i < aspectLength; i++) {
            selectedAspect.push(parseInt(myAspectArray[i].value))
        }

        console.log(selectedAspect)

        let value = {
            'selected_aspect' : selectedAspect
        }

        api.getAssociatedStandards(this.props.user.accessToken, value)
        .then((result) => {
            if (result.status === 'success') {
                editData.standardComboDropDown = result.data
                this.setState({editData:editData})
            }
        })
    }

    handleParentStandardChange = (option) => {
        this.setState(state => {
            return {
                parentStandard : option
            };
        });
    }

    handleModify = (e) => {
        let editData = Object.assign({}, this.state.editData)
        let data = Object.assign({}, this.state.data)
        let parentAspect
        let parentStandard
        let centaRatingDropDown = []

        for (var i = 1; i < 6; i++) {
            var a = {}
            a["id"] = i
            if (i === 1) {
                a["name"] = i + ' Star'
            }
            else {
                a["name"] = i + ' Stars'
            }
            centaRatingDropDown.push(a)
        }

        let url1 = 'admin/learning_taxonomy/languages'
        let newSectionType = 3
        let standardType = 4
        let url2 = `admin/taxonomy_details/${newSectionType}`
        let fetchStandard = `admin/taxonomy_details/${standardType}`
        let url3 = `admin/learning_resource/parent_taxonomy/${this.state.data.resourceId}`
        let getLevelTrackInfo = `admin/learning_resource/tracks_levels_information/${this.state.data.resourceId}`
        let selectedBuzzwordFetch = `admin/learning_resource/buzzwords/${this.state.data.resourceId}`
        let getBuzzwords = 'buzzword'
        let backwardResource = 'admin/learning_resource/render_resources/association_details'
        let exisitingResourceDetails = `admin/learning_resource/render_association/${this.state.data.resourceId}`
        let complexity = 'admin/learning_resource/complexity'
        let blogUrl = 'admin/lr/get/all/posts'

        api.getResponse(this.props.user.accessToken, url1)
        .then((result) => {
            editData.languageDropDown = result
            api.getResponse(this.props.user.accessToken, url2)
            .then((result) => {
                editData.aspectComboDropDown = result.data
                api.getResponse(this.props.user.accessToken, url3)
                .then((result) => {
                    if (result.status === 'success'){
                        parentAspect = result.data.aspects
                        parentStandard = result.data.standards

                        let selectedAspectArray = []
                        var myAspectArray = result.data.aspects
                        var aspectLength = myAspectArray.length;
                        for (var i = 0; i < aspectLength; i++) {
                            selectedAspectArray.push(parseInt(myAspectArray[i].value))
                        }

                        let value = {
                            'selected_aspect' : selectedAspectArray
                        }

                        api.getAssociatedStandards(this.props.user.accessToken, value)
                        .then((result) => {
                            if (result.status === 'success') {
                                editData.standardComboDropDown = result.data
                                api.adminResourceLevelsBox(this.props.user.accessToken)
                                .then((result) => {
                                    editData.levelDropDown = result.data
                                    api.adminResourceTracksBox(this.props.user.accessToken)
                                    .then((result) => {
                                        editData.trackDropDown = result.data
                                        api.getResponse(this.props.user.accessToken, complexity)
                                        .then((result) => {
                                            editData.complexityDropDown = result
                                            editData.centaRatingDropDown = centaRatingDropDown
                                            api.getResponse(this.props.user.accessToken, blogUrl)
                                            .then((result) => {
                                                if(result.status === 'success'){
                                                    editData.blogIdDropDown = result.data
                                                    this.setState({editData: editData, modifyForm: true, parentAspect: parentAspect, parentStandard: parentStandard})
                                                }                                                                                       
                                            })
                                        })
                                    })
                                })
                            }
                        })
                        api.getResponse(this.props.user.accessToken, getLevelTrackInfo)
                        .then((result) => {
                            let parentTrack = result.data.test_track_id
                            editData.levelId = result.data.level_id
                            api.getResponse(this.props.user.accessToken, getBuzzwords)
                            .then((result) => {
                                if (result.status === 'success'){
                                    editData.buzzwordDropDown = result.data
                                    api.getResponse(this.props.user.accessToken, selectedBuzzwordFetch)
                                    .then((result) => {
                                        if (result.status === 'success'){
                                            let parentBuzzword = result.data
                                            this.setState({editData: editData, parentTrack: parentTrack, parentBuzzword: parentBuzzword})
                                        }
                                    })
                                }
                            })
                        })
                        api.getResponse(this.props.user.accessToken, backwardResource)
                        .then((result) => {
                            if (result.status === 'success'){
                                editData.resourceDropDown = result.data
                                api.getResponse(this.props.user.accessToken, exisitingResourceDetails)
                                .then((result) => {
                                    if (result.status === 'success'){
                                        let associatedResource = result.data
                                        this.setState({editData: editData, associatedResource: associatedResource})
                                    }
                                })
                            }
                        })                        

                    }
                })
            })
        })
    }

    handleResourceNameUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceName = event.target.value
        this.setState({editData: editData}) 
    }

    handleResourceAuthorUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceAuthor = event.target.value
        this.setState({editData: editData}) 
    }

    handleResourceCustomIdUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceCustomId = event.target.value
        this.setState({editData: editData}) 
    }

    handleResourceDescUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceDescription = event.target.value
        this.setState({editData: editData}) 
    }

    handleEditorDescriptionUpdate: Function = (editorState) => {
        let editorData = Object.assign({}, this.state.editorData)
        editorData.editorStateRead = editorState
        this.setState({editorData: editorData});
    };

    handleResourceLinkUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceLink = event.target.value
        editData.resourceType = "link"
        editData.blogId = ''
        this.setState({editData: editData}) 
    }


    handleResourceActiveChange = evt => {
        let editData = Object.assign({}, this.state.editData)
        editData.active = evt.target.value
        this.setState({editData: editData})
    }


    handleResourceListingSequenceUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceListingSequence = event.target.value
        this.setState({editData: editData})
    }

    handleBlogIdUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.blogId = event.target.value
        editData.resourceType = 'blog'
        this.setState({editData: editData})
    }

    handleResourceImageLinkUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceImgLink = event.target.value
        this.setState({editData: editData})
    }

    handleLanguageUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.languageId = event.target.value
        this.setState({editData: editData})
    }

    handleComplexityUpdate = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.complexityId = event.target.value
        this.setState({editData: editData})
    }



    handleCommentChange = (event) => {
        let userActivityData = Object.assign({}, this.state.userActivityData)
        userActivityData.comment = event.target.value
        this.setState({userActivityData: userActivityData}) 
    }

    handleResourceUpdate = (e) => {
        e.preventDefault()
        this.setState({saveDisable: true})

        let htmlText = stateToHTML(this.state.editorData.editorStateRead.getCurrentContent())

        if (htmlText.length > 5000){
            return this.setState({errorMsg: 'The description is too long. Please make the necessary changes.', saveDisable: false})
        }
        if((this.state.editData.resourceType === 'link') || (this.state.editData.resourceType === 'blog')){
            if((this.state.editData.resourceLink === '') && (this.state.editData.blogId === '')){
                return this.setState({errorMsg: 'Please select either Blog or Link to update the resource', saveDisable: false})
            }
        }
        if((this.state.editData.resourceType === 'link') || (this.state.editData.resourceType === 'blog')){
            if((this.state.editData.resourceLink !== '') && (this.state.editData.blogId !== '')){
            return this.setState({errorMsg: 'Please select any one - either Blog or Link to update the resource', saveDisable: false })
            }
        }

/*      
        if (this.state.editData.resourceType === 'link'){
            if (this.state.editData.resourceLink === '') {
                return this.setState({errorMsg: 'Please enter the resource link before updating the resource.', saveDisable: false})
            }
        }

        if(this.state.editData.resourceType === 'blog'){
             if (this.state.editData.blogId === '') {
                return this.setState({errorMsg: 'Please select the resource Blog before updating the resource.', saveDisable: false})
            }

        }
*/

        if ((this.state.editData.resourceName === '') || (this.state.editData.resourceDescription === '') || (this.state.editData.languageId === '') || (this.state.editData.complexityId === '') || (this.state.editData.centaRating === '') || (this.state.editData.resourceCustomId === '') || (this.state.editData.resourceListingSequence === '') || (this.state.editData.resourceImgLink === '')){
            return this.setState({errorMsg: 'Please enter the necessary details before updating the resource.', saveDisable: false})
        }

        let data = Object.assign({}, this.state.data)
        const formData = new FormData(e.target);

        var myStringArray = this.state.parentAspect;
        var arrayLength = myStringArray.length;
        let selectedTaxonomyString = []
        for (var i = 0; i < arrayLength; i++) {
            selectedTaxonomyString.push(parseInt(myStringArray[i].value))
        }

        var myStandardArray = this.state.parentStandard;
        var standardLength = myStandardArray.length;
        for (var i = 0; i < standardLength; i++) {
            selectedTaxonomyString.push(parseInt(myStandardArray[i].value))
        }

        var buzzwordArray = this.state.parentBuzzword;
        var arrayLength = buzzwordArray.length;
        let selectedBuzzwordString = []
        for (var i = 0; i < arrayLength; i++) {
            selectedBuzzwordString.push(parseInt(buzzwordArray[i].value))
        }

        var trackArray = this.state.parentTrack;
        var arrayLength = trackArray.length;
        let selectedTrackString = []
        for (var i = 0; i < arrayLength; i++) {
            selectedTrackString.push(parseInt(trackArray[i].value))
        }

        var resourceArray = this.state.associatedResource;
        var arrayLength = resourceArray.length;
        let selectedResourceString = []
        for (var i = 0; i < arrayLength; i++) {
            selectedResourceString.push(parseInt(resourceArray[i].value))
        }

        formData.append("description", htmlText)
        formData.append("selected_taxonomies", selectedTaxonomyString)
        formData.append("test_track_id", selectedTrackString)
        formData.append("buzzwords", selectedBuzzwordString)
        if (this.state.associationChanged === true) {
            formData.append("selected_resources", selectedResourceString)
        }
        api.updateLearningResource(this.props.user.accessToken, this.state.data.resourceId, formData)
        .then((result) => {
            if (result.status === 'success'){
                this.props.onHandleResourceFetch()
                this.setState({modifyForm: false, errorMsg: '', saveDisable: false})
            }
            else {
                this.setState({saveDisable: false})
            }
        })
    }

    handleCancelUpdate = (e) => {
        let data = Object.assign({}, this.state.data)
        this.setState({modifyForm: false, editData: data, errorMsg: '', saveDisable: false})
    }

    updateUserActivity = (values) => {
        let userActivityData = Object.assign({}, this.state.userActivityData)

        api.userUpdateLearningResActivity(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status === 'success') {
                userActivityData.readStatus = result.data.read_status
                userActivityData.bookmarkStatus = result.data.bookmark_status
                userActivityData.archiveStatus = result.data.archive_status
                userActivityData.existingRating = result.data.ratings
                if ((result.target_month_label !== '') || (result.target_month_label !== null)) {
                    userActivityData.userSelectedMonth = result.target_month_label
                }
                this.props.onHandleResourceFetch()
                this.setState({changeTargetMonth: false, userActivityData: userActivityData, errorMsg: ''})
            }
        })
    }

    bookmarkResource = (e, bookmarkStatus) => {
        let userActivityData = Object.assign({}, this.state.userActivityData)
        let values
        if (bookmarkStatus === true){
            if (this.state.targetMonth.length === 0){
                return this.setState({errorMsg: 'Please select a Target month to add the Resource to your learning plan.'})
            }
            
            values = {
                'learningResUserActivity':{
                    'learningResourceId' : this.state.data.resourceId,
                    'bookmarkStatus': bookmarkStatus,
                    'targetMonth': this.state.targetMonth['value']
                }
            }
        }
        else {
            values = {
                'learningResUserActivity':{
                    'learningResourceId' : this.state.data.resourceId,
                    'bookmarkStatus': bookmarkStatus,
                    'targetMonth': ''
                }
            }
        }

        this.updateUserActivity(values)
    }

    archiveResource = (e, archiveStatus, bookmarkStatus) => {
        let userActivityData = Object.assign({}, this.state.userActivityData)

        let values = {
            'learningResUserActivity':{
                'learningResourceId' : this.state.data.resourceId,
                'bookmarkStatus': bookmarkStatus,
                'archiveStatus': archiveStatus,
                'targetMonth': ''
            }
        }

        this.updateUserActivity(values)
    }

    readResource = (e, readStatus) => {
        let userActivityData = Object.assign({}, this.state.userActivityData)

        let values = {
            'learningResUserActivity':{
                'learningResourceId' : this.state.data.resourceId,
                'readStatus': readStatus
            }
        }

        this.updateUserActivity(values)
    }

    changeRating = (newRating) => {

        let userActivityData = Object.assign({}, this.state.userActivityData)

        let values = {
            'learningResUserActivity':{
                'learningResourceId' : this.state.data.resourceId,
                'ratings': newRating
            }
        }

        api.userUpdateLearningResActivity(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status === 'success') {
                userActivityData.readStatus = result.data.read_status
                userActivityData.bookmarkStatus = result.data.bookmark_status
                userActivityData.archiveStatus = result.data.archive_status
                userActivityData.existingRating = result.data.ratings
                this.setState({userActivityData: userActivityData, userRatingView: 'rated'})
            }
        })
    }

    handleResAssociatedTracks = (option) => {
        this.setState(state => {
            return {
                parentTrack : option
            };
        });
    }

    handleBuzzwords = (option) => {
        this.setState(state => {
            return {
                parentBuzzword : option
            };
        });
    }

    handleTargetMonth = (option) => {
        this.setState(state => {
            return {
                targetMonth: option
            };
        });
    }

    handleResourceAssociation = (option) => {
        this.setState(state => {
            return {
                associationChanged: true,
                associatedResource : option
            };
        });
    }

    handleLevelsChange = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.levelId = event.target.value
        this.setState({editData: editData})
    }

    handleCentaRatingChange = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.centaRating = event.target.value
        this.setState({editData: editData})
    }

    handleResourceClassChange = (event) => {
        let editData = Object.assign({}, this.state.editData)
        editData.resourceClass = event.target.value
        this.setState({editData: editData})
    }

    submitUserReview = (event) => {
        if (this.state.userActivityData.comment === null) {
            return this.setState({errorMsg: 'Please provide a review to submit your response.'})
        }
        if (this.state.userActivityData.comment === '') {
            return this.setState({errorMsg: 'Please complete the review to submit your response.'})
        }
        else {
            if (this.state.userActivityData.comment.length > 250){
                return this.setState({errorMsg: 'The characters in your response exceeds 250 characters. Please make sure that the review is within 250 characters limit.'})
            }
        }
        let values = {
            'learningResourceId': this.state.data.resourceId,
            'review': this.state.userActivityData.comment
        }
        api.userSubmitUserReview(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status === 'success'){
                this.setState({submitReviewButton: false, errorMsg: ''})
            }
            else if (result.status === 'error'){
                this.setState({submitReviewButton: true, errorMsg: 'Error in submitting review. Please try again.'})
            }
            else if (result.status === 'already_exists'){
                this.setState({submitReviewButton: false, errorMsg: 'You have already reviewed the resource.'})
            }
        })
    }

    readUserReview = (e) => {
        e.preventDefault()
        let fetchUserReviews = `admin/learning_resource/render_user_reviews/${this.state.data.resourceId}`
        let userActivityData = Object.assign({}, this.state.userActivityData)

        api.getUserResponse(this.props.user.accessToken, fetchUserReviews)
        .then((result) => {
            if (result.status === 'success') {
                userActivityData.userReviews = result.data
                this.setState({userActivityData: userActivityData})
            }
        })
        this.setState({moreDetails: true, detailsView: false})
    }

    handleDetailsView = (e) => {
        this.setState({moreDetails: true, detailsView: true})
    }

    validateUpload = (event) =>{
        let uploadDisableButton
        let file_name = event.target.files[0].name;
        let extension = file_name.substring(file_name.lastIndexOf('.') + 1).toLowerCase();
        let fileError

        if (extension == "pdf"){
            this.setState({uploadDisableButton: false, fileError: ''})
        }
        else{
            this.setState({uploadDisableButton: true, fileError: 'Invalid File Format. Upload PDF file only.'})
        }
    }

    handleResourceView = (e) => {
        if (this.props.isAdmin === false){
            console.log("Resource Viewed")
        }
    }

    changeBookmark = (e) => {
        if (this.state.changeTargetMonth === false) {
            this.setState({changeTargetMonth: true})
        }
        else {
            this.setState({changeTargetMonth: false})
        }
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)
        let editorData = Object.assign({}, this.state.data)

        data.resourceId = this.props.resourceId
    	data.resourceName = this.props.resourceName
    	data.resourceLink = this.props.resourceLink
    	data.resourceAuthor = this.props.resourceAuthor
        data.resourceDescription = this.props.shortDescription
    	data.resourceLanguage = this.props.resourceLanguage
    	data.resourceCreationDate = this.props.resourceCreationDate
        data.resourceStatus = this.props.resourceStatus
        data.resourceType = this.props.resourceType
        data.languageId = this.props.languageId
        data.buzzwords = this.props.buzzwords
        data.ratings = this.props.ratings
        data.resourceComplexity = this.props.resourceComplexity
        data.complexityId = this.props.complexityId
        data.centaRating = parseInt(this.props.centaRating)
        data.resourceClass = this.props.resourceClass
        data.resourceCustomId = this.props.resourceCustomId
        data.listingSequence = this.props.listingSequence
        data.imgLink = this.props.imgLink
        data.active = this.props.active
        data.blogId = this.props.blogId
        let contentValue = convertFromHTML(this.props.resourceDescription)
        const contentState = ContentState.createFromBlockArray(contentValue);
        editorData.editorStateRead = EditorState.createWithContent(contentState);
        if(data.active === true){
          data.active = 1
        }
        else if(data.active === false){
          data.active = 0
        }
        this.setState({data: data, editData: data, editorData: editorData})
    }

    render() {
    	let handleDetails = this.handleDetails
        let handleModify = this.handleModify
        let handleCancelUpdate = this.handleCancelUpdate
        let handleResourceUpdate = this.handleResourceUpdate
        let bookmarkResource = this.bookmarkResource
        let archiveResource = this.archiveResource
        let readResource = this.readResource
        let submitUserReview = this.submitUserReview
        let readUserReview = this.readUserReview
        let handleDetailsView = this.handleDetailsView
        let changeBookmark = this.changeBookmark
        let handleResourceView = this.handleResourceView
    	let displayComponent, firstActionComponent, secondActionComponent, thirdActionComponent, centaRatingComponent, listingSequenceComponent, activeComponent, LrBlogComponent
    	let dateComponent, detailsButton,  detailsComponent, buzzwordComponent, uploadButtonComponent, preReadComponent, postReadComponent
        let editFormComponent, hiddenComponent, ratingTextComponent, ratingComponent, reviewComponent, reviewSubmitComponent, descriptionComponent
        let monthComponent, submitBookmarkComponent, removeBookmarkComponent, changeBookmarkComponent, closeBookmarkChange, resourceClassComponent
        let rateFloat = parseFloat(this.state.userActivityData.rating)

        if (this.state.data.preReads.length > 0) {
            preReadComponent = (                   
                <GridCell span = "5">
                    <Typography use="headline7" align = "left"> The <b>Pre-Reads</b> for this resource are: </Typography>
                    <ul>
                        {this.state.data.preReads.map(function(read){
                            return (
                                <Typography use="captions" align = "left"><li>{read.name}</li></Typography>
                            )
                        })}
                    </ul>
                </GridCell>
            )
        }
        else {
            preReadComponent = (
                <GridCell span = "5">
                    <Typography use="headline7" align = "left"><b>Pre-Reads</b> : None</Typography>
                </GridCell>
            )
        }

        if (this.state.data.postReads.length > 0) {
            postReadComponent = (
                <GridCell span = "5">
                    <Typography use="headline7" align = "right"> The <b>Post-Reads</b> for this resource are: </Typography>
                    <ul>
                        {this.state.data.postReads.map(function(read){
                            return (
                                <Typography use="captions"><li>{read.name}</li></Typography>
                            )
                        })}
                    </ul>
                </GridCell>
            )
        }
        else {
            postReadComponent = (
                <GridCell span = "5">
                    <Typography use="headline7" align = "right"><b>Post-Reads</b> : None</Typography>
                </GridCell>
            )
        }

        if (this.props.isAdmin === false) {
            if (this.state.userRatingView === 'not_rated'){
                ratingComponent = (
                    <GridCell span = "3">
                        <StarRatings
                            rating={rateFloat}
                            starDimension="25px"
                            starSpacing="4px"
                            starRatedColor="wheat"
                            starSelectingHoverColor = "yellow"
                            changeRating={this.changeRating}
                            numberOfStars={5}
                            name='rating'
                        />
                    </GridCell>
                )
                ratingTextComponent = (
                    <GridCell span = "3">
                        <Typography><b>Please rate the resource:</b></Typography>
                    </GridCell>
                )
                if (this.state.submitReviewButton === true) {
                    reviewComponent = (
                        <GridCell span = "12">
                            <TextField fullwidth className = 'test_input' label="Enter your review(maximum 250 characters)" autoComplete="off"  name="resource_link" defaultValue = {this.state.userActivityData.comment} onChange = {this.handleCommentChange} style={{ height: '140%' }}/>
                        </GridCell>
                    )
                    reviewSubmitComponent = (
                        <GridCell span = "12">
                            <Button raised style={{ width: '25%' }} onClick = {((e) => submitUserReview(e))}>Submit Review</Button>
                        </GridCell>
                    )
                }
                else {
                    reviewComponent = (
                        <GridCell span = "12">
                            <TextField fullwidth disabled className = 'test_input' label="Enter your review" autoComplete="off"  name="resource_link" defaultValue = {this.state.userActivityData.comment} onChange = {this.handleCommentChange} style={{ height: '140%' }}/>
                        </GridCell>
                    )
                    reviewSubmitComponent = (
                        <GridCell span = "12">
                            <Button raised disabled style={{ width: '30%' }}>Thanks for reviewing</Button>
                        </GridCell>
                    )
                }
            }
            else if (this.state.userRatingView === 'rated'){
                let rateFloat = parseFloat(this.state.userActivityData.existingRating)
                ratingTextComponent = (
                    <GridCell span = "3">
                        <Typography><b>Thank you for rating the resource.</b></Typography>
                    </GridCell>
                )
                ratingComponent = (
                    <GridCell span = "3">
                        <StarRatings
                            rating={rateFloat}
                            starDimension="25px"
                            starSpacing="4px"
                            starRatedColor="wheat"
                        />
                    </GridCell>
                )
                if (this.state.submitReviewButton === true) {
                    reviewComponent = (
                        <GridCell span = "12">
                            <TextField fullwidth className = 'test_input' rows="1" label="Enter your review" autoComplete="off"  name="resource_link" defaultValue = {this.state.userActivityData.comment} onChange = {this.handleCommentChange} style={{ height: '140%' }}/>
                        </GridCell>
                    )
                    reviewSubmitComponent = (
                        <GridCell span = "12">
                            <Button raised style={{ width: '25%' }} onClick = {((e) => submitUserReview(e))}>Submit Review</Button>
                        </GridCell>
                    )
                }
                else {
                    reviewComponent = (
                        <GridCell span = "12">
                            <TextField fullwidth disabled className = 'test_input' rows="1" label="Enter your review" autoComplete="off"  name="resource_link" defaultValue = {this.state.userActivityData.comment} onChange = {this.handleCommentChange} style={{ height: '140%' }}/>
                        </GridCell>
                    )
                    reviewSubmitComponent = (
                        <GridCell span = "12">
                            <Button raised disabled style={{ width: '30%' }}>Thanks for reviewing</Button>
                        </GridCell>
                    )
                }
            }
            centaRatingComponent = (
                <GridCell span = "3">
                </GridCell>
            )

            resourceClassComponent = (
                <GridCell span = "3">
                </GridCell>
            )
        }
        else {
            if (this.state.data.centaRating !== null) {
                if (parseInt(this.state.data.centaRating) === 1) {
                    centaRatingComponent = (
                        <GridCell span = "3">
                            <Typography> <b>CENTA Rating:</b> <i>{this.state.data.centaRating}</i> Star</Typography>
                        </GridCell>
                    )
                }
                else {
                    centaRatingComponent = (
                        <GridCell span = "3">
                            <Typography> <b>CENTA Rating:</b> <i>{this.state.data.centaRating}</i> Stars</Typography>
                        </GridCell>
                    )
                }
            }
            else {
                centaRatingComponent = (
                    <GridCell span = "3">
                    </GridCell>
                )
            }
            
            if (this.state.data.resourceClass === 'external') {
                resourceClassComponent = (
                    <GridCell span = "3">
                        <Typography> <b>Resource Type:</b> <i>External</i></Typography>
                    </GridCell>
                )
            }
            else if (this.state.data.resourceClass === 'internal') {
                resourceClassComponent = (
                    <GridCell span = "3">
                        <Typography> <b>Resource Type:</b> <i>Internal</i></Typography>
                    </GridCell>
                )
            }
            else {
                resourceClassComponent = (
                    <GridCell span = "3">
                    </GridCell>
                )
            }

            buzzwordComponent = (
                <GridCell span = "12">
                    <Typography> <b>Keywords:</b> <i>{this.state.data.buzzwords}</i> </Typography>
                </GridCell>
            )

            if (this.state.data.ratings != null) {
                ratingTextComponent = (
                    <GridCell span = "3">
                        <Typography> The average ratings for this resource is: </Typography>
                    </GridCell>
                )
                let rateFloat = parseFloat(this.state.data.ratings)
                ratingComponent = (
                    <GridCell span = "3">
                        <StarRatings
                            rating={rateFloat}
                            starDimension="25px"
                            starSpacing="4px"
                            starRatedColor="wheat"
                        />
                    </GridCell>
                )
                reviewComponent = (
                    <GridCell span = "3">
                        <Button raised style={{ width: '80%' }} onClick = {((e) => readUserReview(e))}>Read Reviews</Button>
                    </GridCell>
                )
            }
            else {
                ratingTextComponent = (
                    <GridCell span = "3">
                        <Typography> Resource not yet rated. </Typography>
                    </GridCell>
                )
                ratingComponent = (
                    <GridCell span = "3">
                    </GridCell>
                )
                reviewComponent = (
                    <GridCell span = "3">
                        <Button raised style={{ width: '80%' }} onClick = {((e) => readUserReview(e))}>Read Reviews</Button>
                    </GridCell>
                )
            }
        }

        if ((this.state.moreDetails === false) && (this.props.archiveFeature === false)) {
            if ((this.state.data.resourceDescription.length > 0) && (this.state.data.resourceDescription.length < 100)) {
                descriptionComponent = (
                    <GridCell span = "12">
                        <Typography align = "left"><b>Description:</b> <i>{this.state.data.resourceDescription}</i></Typography>
                    </GridCell>
                )
            }
            else if (this.state.data.resourceDescription.length > 100) {
                //let description = this.state.data.resourceDescription.substr(0, this.state.data.resourceDescription.indexOf('.'))+ '...'
                let descriptionSplit = this.state.data.resourceDescription.split('.')
                let description = descriptionSplit[0] + '...'
                descriptionComponent = (
                    <GridCell span = "12">
                        <Typography align = "left"><b>Description:</b> <i>{description}</i></Typography>
                    </GridCell>
                )
            }
        }

        if (this.props.isAdmin === true){
            firstActionComponent = (
                <GridCell span = "12">
                    <Button raised style={{ width: '20%' }} onClick = {((e) => handleModify(e))}>Modify Resource</Button>
                </GridCell>
            )
        }
        else {
            if (this.props.bookmarkFeature === true) {
                if (this.state.changeTargetMonth === true) {
                    let addBookmarkStatus = true
                    let removeBookmarkStatus = false
                    if (this.state.userActivityData.bookmarkStatus === true) {
                        submitBookmarkComponent = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '75%' }} onClick= {((e) => bookmarkResource(e, addBookmarkStatus))}>Add</Button>
                            </GridCell>
                        )

                        removeBookmarkComponent = (
                            <GridCell span = "2">
                                <Button raised style={{ width: '75%' }} onClick= {((e) => bookmarkResource(e, removeBookmarkStatus))}>Remove</Button>
                            </GridCell>
                        )
                    }
                    else {
                        submitBookmarkComponent = (
                            <GridCell span = "2">
                                <Button raised style={{ width: '75%' }} onClick= {((e) => bookmarkResource(e, addBookmarkStatus))}>Add</Button>
                            </GridCell>
                        )

                        removeBookmarkComponent = (
                            <GridCell span = "2">
                                <Button dense style={{ width: '75%' }} onClick= {((e) => bookmarkResource(e, removeBookmarkStatus))}>Remove</Button>
                            </GridCell>
                        )
                    }
                    firstActionComponent  = (
                        <GridCell span = "4" style={{padding: '5px'}}>
                            <Typography>Add to My Learning Plan:</Typography>
                        </GridCell>
                    )

                    monthComponent = (
                        <GridCell span="3">
                            <Reactsel
                                name="monthlist"
                                onChange={this.handleTargetMonth}
                                defaultValue={this.state.targetMonth}
                                value={this.state.targetMonth}
                                options={this.state.userActivityData.targetMonthDropDown}
                                placeholder="--Select Target Month--">
                            </Reactsel>
                        </GridCell>
                    )
                    closeBookmarkChange = (
                        <GridCell span="1">
                            <ListItemGraphic onClick={((e) => changeBookmark(e))} style={{cursor: 'pointer'}} data-tip={'Close'}>close</ListItemGraphic>
                            <ReactTooltip place="top" type="dark" effect="solid"/>
                        </GridCell>
                    )
                }
                else {
                    firstActionComponent  = (
                        <GridCell span = "3" style={{padding: '5px'}}>
                            <Typography>Learning Plan(Target Month):</Typography>
                        </GridCell>
                    )

                    monthComponent = (
                        <GridCell span="3" style={{padding: '5px'}}>
                            <Typography>{this.state.userActivityData.userSelectedMonth}</Typography>
                        </GridCell>
                    )

                    changeBookmarkComponent = (
                        <GridCell span = "6">
                            <Button dense style={{ width: '35%' }} onClick= {((e) => changeBookmark(e))}>Add/Change</Button>
                        </GridCell>
                    )
                }
            }
        }

        if (this.props.isAdmin === true){
            if (this.state.data.resourceStatus === true) {
                secondActionComponent = (
                    //<GridCell span="1">
                    //    <ListItemGraphic style={{cursor: 'pointer'}} data-tip={'Disable'}>close</ListItemGraphic>
                    //    <ReactTooltip place="top" type="dark" effect="solid"/>
                    //</GridCell>
                    <GridCell span="1">
                    </GridCell>
                )
            }
            else {
                secondActionComponent = (
                    //<GridCell span="1">
                    //    <ListItemGraphic style={{cursor: 'pointer'}} data-tip={'Enable'}>refresh</ListItemGraphic>
                    //    <ReactTooltip place="top" type="dark" effect="solid"/>
                    //</GridCell>
                    <GridCell span="1">
                    </GridCell>
                )   
            }
        }
        else {
            if (this.props.archiveFeature === true) {
                if (this.state.userActivityData.archiveStatus === true){
                    let nowArchiveStatus = false
                    let nowBookmarkStatus = false
                    secondActionComponent  = (
                        <div>
                            <ListItemGraphic onClick= {((e) => archiveResource(e, nowArchiveStatus, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Remove Resource from Archive'}>unarchive</ListItemGraphic>
                            <ReactTooltip place="top" type="dark" effect="solid"/>
                        </div>
                    )
                }
                else {
                    let nowArchiveStatus = true
                    let nowBookmarkStatus = false
                    secondActionComponent  = (
                        <div>
                            <ListItemGraphic onClick= {((e) => archiveResource(e, nowArchiveStatus, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Add Resource to Archive'}>archive</ListItemGraphic>
                            <ReactTooltip place="top" type="dark" effect="solid"/>
                        </div>
                    )
                }
            }
        }

        if (this.props.isAdmin === false){
            if (this.state.userActivityData.readStatus === true){
                let nowReadStatus = false
                thirdActionComponent  = (
                    <GridCell span = "3">
                        <Button dense style={{ width: '100%'}} onClick= {((e) => readResource(e, nowReadStatus))}>Mark as Unread</Button>
                    </GridCell>
                )
            }
            else {
                let nowReadStatus = true
                thirdActionComponent  = (
                    <GridCell span = "3">
                        <Button dense style={{ width: '100%'}} onClick= {((e) => readResource(e, nowReadStatus))}>Mark as Read</Button>
                    </GridCell> 
                )
            }
        }

        if (this.props.isAdmin === true){
            dateComponent = (
                <GridCell span="4">
                    <Typography use = "caption">Created at:  <b>{this.state.data.resourceCreationDate}</b></Typography>
                </GridCell>
            )
        }
        else {
            dateComponent = (
                <GridCell span="4">
                </GridCell>
            )
        }

      if (this.props.isAdmin === true){
            listingSequenceComponent = (
                <GridCell span = "3">
                  <Typography align = "left"><b>Listing Sequence :</b> <i>{this.state.data.listingSequence}</i></Typography>
                </GridCell>
            )
        }
        else {
            listingSequenceComponent = (
                <GridCell span = "3">
                </GridCell>
            )
        }

      if(this.props.isAdmin === true){
        activeComponent = (
        <GridCell span = "12">
          <Select
            name = 'active'
            onChange={this.handleResourceActiveChange} 
            value={this.state.editData.active}
          >
            <option value = "1">Active</option>
            <option value = "0">Inactive</option>
          </Select>
        </GridCell>
        )
      }
      else{
            activeComponent = (
                <GridCell span = "12">
                </GridCell>
            )
        }


    	if (this.state.moreDetails === false){
			detailsButton = (<Button dense style={{ width: '100%'}} onClick = {((e) => handleDetails(e))}>More Details</Button>)
    	}
    	else {
    		detailsButton = (<Button raised style={{ width: '100%'}} onClick = {((e) => handleDetails(e))}>Less Details</Button>)
    	}

    	if ((this.state.moreDetails === true) && (this.state.detailsView === true)){
    		detailsComponent = (
                <div>
        			<Grid>
                        <GridCell span = "12">
                            <Typography align = "left"><b>Tagged to CENTA Standards :</b> <i>{this.props.parentTags}</i></Typography>
                        </GridCell>
                        <GridCell span = "12">
                            <Typography align = "left"><b>Description : </b></Typography>
                            <DiffEditor editorState={this.state.editorData.editorStateRead} readOnly/>
                        </GridCell>
                        <GridCell span = "12">
                            <Typography align = "left"><b>Author :</b> <i>{this.state.data.resourceAuthor}</i></Typography>
                        </GridCell>
                        <GridCell span="6">
                            <Typography align = "left"> <b>Language :</b> <i>{this.state.data.resourceLanguage}</i></Typography>
                        </GridCell>
                        <GridCell span="6">
                            <Typography align = "left"> <b>Complexity :</b> <i>{this.state.data.resourceComplexity}</i></Typography>
                        </GridCell>
                        {activeComponent}
                        <GridCell span = "3">
                          <Typography align = "left"><b>Image Link :</b> <i>{this.state.data.imgLink}</i></Typography>
                        </GridCell>
                        {listingSequenceComponent}
                        {centaRatingComponent}
                        {resourceClassComponent}
                        {preReadComponent}
                        <GridCell span = "2">
                        </GridCell>
                        {postReadComponent}
                        {closeBookmarkChange}
                        {firstActionComponent}
                        {monthComponent}
                        {submitBookmarkComponent}
                        {removeBookmarkComponent}
                        {changeBookmarkComponent}
                        {ratingTextComponent}
                        {ratingComponent}
                        {secondActionComponent}
                        {thirdActionComponent}
                        {reviewComponent}
                        {reviewSubmitComponent}
                        {buzzwordComponent}
                        <GridCell span = "12">
                            <StatusMessage error_msg = {this.state.errorMsg} />
                        </GridCell>
        			</Grid>
                </div>
    		)
    	}
        else if ((this.state.moreDetails === true) && (this.state.detailsView === false)){
            if (this.state.userActivityData.userReviews.length > 0) {
                detailsComponent = (
                    <div>
                        <div className = "review-panel" >
                            <Grid className= "opportunity-list-item">
                                {this.state.userActivityData.userReviews.map(function(review){
                                    return (
                                        <GridCell span = "12">
                                            <Typography>{review.user_review} - <i>{review.user_name}</i></Typography>
                                        </GridCell>
                                    )
                                })}
                            </Grid>
                        </div>
                        <Grid className= "opportunity-list-item">
                            <GridCell span = "4">
                                <Button raised style={{ width: '50%' }} onClick= {((e) => this.handleDetailsView(e))}>View Details</Button>
                            </GridCell>
                        </Grid>
                    </div>
                )
            }
            else {
                detailsComponent = (
                    <div>
                        <Grid className = "opportunity-list-item">
                            <GridCell span = "12">
                                <Typography> There are no reviews for this resource.</Typography>
                            </GridCell>
                            <GridCell span = "4">
                                <Button raised style={{ width: '50%' }} onClick= {((e) => this.handleDetailsView(e))}>View Details</Button>
                            </GridCell>
                        </Grid>
                    </div>
                )
            }
        }

        if (this.state.data.resourceType === 'document'){
            editFormComponent = (
                    <GridCell span="12">
                        <Typography>Please add the resource document to modify:  </Typography><input type="file" id="PdfUpload" name="artifact" onChange={this.validateUpload} />
                    </GridCell>
            )
            hiddenComponent = (
                <div>
                    <TextField autoComplete="off" hidden name="resourcetype"  defaultValue="document"/>
                </div>
            )
        }
        else if ((this.state.data.resourceType === 'link') || (this.state.data.resourceType === 'blog')) {
            editFormComponent = (
            <GridCell span = "12">
                <GridCell span="12">
                    <TextField fullwidth className = 'test_input' label="Link of the Resource" autoComplete="off"  name="resource_link" defaultValue = {this.state.editData.resourceLink} onChange = {this.handleResourceLinkUpdate} style={{ height: '140%' }}/>
                </GridCell>
                <br/>
            </GridCell>
            )
            hiddenComponent = (
                <div>
                    <TextField autoComplete="off" hidden name="resourcetype"  value={this.state.editData.resourceType}/>
                </div>
            )
            if(this.props.isAdmin == true){
            LrBlogComponent = (
            <GridCell span = "12">
                    <Select
                    name = 'resource_journal'
                    onChange = {this.handleBlogIdUpdate}
                    defaultValue={this.state.editData.blogId}
                    value = {this.state.editData.blogId}
                    placeholder = "Please select a Blog">
                    {this.state.editData.blogIdDropDown && this.state.editData.blogIdDropDown.map(blog => (
                        <option key={blog.id} value={blog.id} data-name={blog.title}>
                            {blog.title}
                        </option>
                    ))}
                    </Select>
                </GridCell>
            )
            hiddenComponent = (
                <div>
                    <TextField autoComplete="off" hidden  name="resourcetype"  value={this.state.editData.resourceType}/>
                </div>
            )
        }

        else{
            LrBlogComponent = (
                <GridCell span = "12">
                </GridCell>
            )
        }

        }



        if (this.state.saveDisable === false) {
            if (this.state.uploadDisableButton === false) {
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
            else {
                uploadButtonComponent = (
                    <GridCell span = "3">
                        <Button raised disabled style={{ width: '100%'}}>Save</Button>
                    </GridCell>
                )
            }
        }
        else {
            uploadButtonComponent = (
                <GridCell span = "3">
                    <Button raised disabled style={{ width: '100%'}}>In Process</Button>
                </GridCell>
            )
        }

        if (this.state.modifyForm === false) {
        	displayComponent = (
                <div>
            		<Grid className="opportunity-list-item">
        				<GridCell span="3">
        					 <Typography> <b>{this.state.data.resourceName}</b> </Typography>
        				</GridCell>
        				<GridCell span="2">
                           <Typography onClick = {((e) => this.handleResourceView(e))}> <a href={this.state.data.resourceLink} target="_blank" style={{cursor: 'pointer'}}> View </a> </Typography>
                        </GridCell>
                        {dateComponent}
                        <GridCell span="3">
                        	{detailsButton}
                        </GridCell>
                        {descriptionComponent}
        			</Grid>
                    {detailsComponent}
                </div>
        	)
        }
        else {
            
            displayComponent = (
                <div>
                    <form onSubmit= {((e) => this.handleResourceUpdate(e))} style={{ width: '100%' }}>
                        <Grid className="opportunity-list-item">
                        <GridCell span="6">
                            <TextField fullwidth label="Name of the Resource" autoComplete="off"  name="name" defaultValue = {this.state.editData.resourceName} onChange = {this.handleResourceNameUpdate} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="6">
                            <TextField fullwidth label="Author" name="author" defaultValue = {this.state.editData.resourceAuthor} onChange={this.handleResourceAuthorUpdate} style={{ height: '140%' }}/>
                        </GridCell>
                        {editFormComponent}
                        {LrBlogComponent}
                        <GridCell span="4">
                            <TextField fullwidth label="Custom ID" name="custom_id" defaultValue = {this.state.editData.resourceCustomId} onChange={this.handleResourceAuthorUpdate} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="8">
                            <TextField fullwidth label="Image Link" name="img_link" defaultValue = {this.state.editData.imgLink} onChange={this.handleResourceImageLinkUpdate} style={{ height: '140%' }}/>
                        </GridCell>
                        <GridCell span="6">
                            <TextField fullwidth label="Listing Sequence" name="listing_sequence" type="number" defaultValue = {this.state.editData.listingSequence} onChange={this.handleResourceListingSequenceUpdate} style={{ height: '140%' }}/>
                        </GridCell>
                        {activeComponent}
                        <GridCell span = "6">
                            <Select
                                name="complexity_id"
                                onChange={this.handleComplexityUpdate}
                                defaultValue={this.state.editData.complexityId}
                                value={this.state.editData.complexityId}
                                className="select-component"
                                placeholder="--Select the Complexity--">
                                {this.state.editData.complexityDropDown.map(list => (
                                    <option key={list.id} value={list.id} data-name={list.name}>
                                        {list.name}
                                    </option>
                                ))}
                            </Select>
                        </GridCell>
                        <GridCell span = "6">
                            <Select
                                name="language_id"
                                onChange={this.handleLanguageUpdate}
                                defaultValue={this.state.editData.languageId}
                                value={this.state.editData.languageId}
                                className="select-component"
                                placeholder="--Select the Language--">
                                {this.state.editData.languageDropDown.map(list => (
                                    <option key={list.id} value={list.id} data-name={list.name}>
                                        {list.name}
                                    </option>
                                ))}
                            </Select>
                        </GridCell>
                        <GridCell span="4">
                            <Select
                                name="resource_type"
                                onChange={this.handleResourceClassChange}
                                defaultValue={this.state.editData.resourceClass}
                                value={this.state.editData.resourceClass}
                                className="select-component" 
                                placeholder="--Internal or External--" >
                                <option value="internal">Internal</option>
                                <option value="external">External</option>
                                        
                            </Select>
                        </GridCell>
                        <GridCell span="4">
                            <Select
                                name="centa_rating"
                                onChange={this.handleCentaRatingChange}
                                value={this.state.editData.centaRating}
                                className="select-component"
                                placeholder="--Select CENTA Rating--">
                                {this.state.editData.centaRatingDropDown.map(rating => (
                                    <option key={rating.id} value={rating.id} data-name={rating.name}>
                                        {rating.name}
                                    </option>
                                ))}
                            </Select>
                        </GridCell>
                        <GridCell span="4">
                            <Select
                                name="level_id"
                                onChange={this.handleLevelsChange}
                                defaultValue={this.state.editData.levelId}
                                value={this.state.editData.levelId}
                                className="select-component"
                                placeholder="--Select Level--">
                                {this.state.editData.levelDropDown.map(level => (
                                    <option key={level.value} value={level.value} data-name={level.label}>
                                        {level.label}
                                    </option>
                                ))}
                            </Select>
                        </GridCell>
                        <GridCell span="6">
                            <Reactsel
                                name="buzzwordslist"
                                onChange={this.handleBuzzwords}
                                defaultValue={this.state.parentBuzzword}
                                value={this.state.parentBuzzword}
                                options={this.state.editData.buzzwordDropDown}
                                placeholder="--Select associated Keywords--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                        <GridCell span = "6">
                            <Reactsel
                                name="taxonomylist"
                                onChange={this.handleParentAspectChange}
                                defaultValue={this.state.parentAspect}
                                value={this.state.parentAspect}
                                options={this.state.editData.aspectComboDropDown}
                                placeholder="--Select an Aspect--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                        <GridCell span = "12">
                            <Reactsel
                                name="standardlist"
                                onChange={this.handleParentStandardChange}
                                defaultValue={this.state.parentStandard}
                                value={this.state.parentStandard}
                                options={this.state.editData.standardComboDropDown}
                                placeholder="--Select a Standard--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                        <GridCell span="12">
                            <Reactsel
                                name="trackslist"
                                onChange={this.handleResAssociatedTracks}
                                defaultValue={this.state.parentTrack}
                                value={this.state.parentTrack}
                                options={this.state.editData.trackDropDown}
                                placeholder="--Select Track--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                        <GridCell span="12">
                            <Reactsel
                                name="resourcelist"
                                onChange={this.handleResourceAssociation}
                                defaultValue={this.state.associatedResource}
                                value={this.state.associatedResource}
                                options={this.state.editData.resourceDropDown}
                                placeholder="--Select Pre-Read Resource--"
                                isMulti>
                            </Reactsel>
                        </GridCell>
                        <GridCell span="12">
                            <Editor
                                editorState={this.state.editorData.editorStateRead}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                onEditorStateChange={this.handleEditorDescriptionUpdate}
                                toolbar={{
                                    options:['inline', 'list' ],
                                    link: { inDropdown: true },
                                    inline:
                                        {
                                            options:['bold', 'italic', 'underline']
                                        },
                                }}
                            />
                        </GridCell>
                        {uploadButtonComponent}
                        <GridCell span = "3">
                            <Button dense style={{ width: '100%'}} onClick= {((e) => this.handleCancelUpdate(e))}>Cancel</Button>
                        </GridCell>
                        <GridCell span = "2">
                            {hiddenComponent}
                        </GridCell>
                        <GridCell span = "12">
                            <StatusMessage error_msg = {this.state.errorMsg} />
                        </GridCell>
                        </Grid>
                    </form>
                </div>
            )
        }

    	return (
    		<div>
    			{displayComponent}
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceComponent);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/ResourceComponent.jsx